
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.873 13.953a.547.547 0 01-.547.547H2.92a2.19 2.19 0 01-2.188-2.188V2.688A2.19 2.19 0 012.92.5h6.723a2.19 2.19 0 012.188 2.188V7.91a.547.547 0 01-1.094 0V2.687c0-.603-.49-1.093-1.094-1.093H2.92c-.603 0-1.094.49-1.094 1.093v9.626c0 .603.49 1.093 1.094 1.093h2.406c.302 0 .547.245.547.547zM9.097 3.781H3.464a.547.547 0 100 1.094h5.633a.547.547 0 000-1.094zm.546 2.735a.547.547 0 00-.546-.547H3.464a.547.547 0 100 1.093h5.633a.547.547 0 00.546-.546zm-6.18 1.64a.547.547 0 100 1.094h2.875a.547.547 0 100-1.094H3.464zm9.72 4.006c-.018.027-.084.12-.125.172-.184.23-.612.77-1.209 1.246-.765.61-1.552.92-2.34.92-.787 0-1.574-.31-2.339-.92-.596-.476-1.025-1.015-1.208-1.246a4.66 4.66 0 01-.126-.172.547.547 0 010-.629 7.691 7.691 0 011.335-1.418c.764-.61 1.551-.92 2.339-.92.787 0 1.574.31 2.34.92.596.476 1.024 1.016 1.208 1.246.04.052.107.145.126.172a.547.547 0 010 .629zm-1.14-.314c-.87-1.035-1.72-1.559-2.533-1.559-.812 0-1.664.524-2.533 1.559.87 1.034 1.72 1.558 2.533 1.558.812 0 1.664-.524 2.533-1.558zm-2.506-1.04a1.039 1.039 0 100 2.079 1.039 1.039 0 000-2.078z"}})])
          )
        }
      }
    